export default __webpack_public_path__ + "static/media/acct-report-hours.ace697bb.png";